import styled from '@emotion/styled';
import ExpandLess from '@portalterreno/react-ui-icons/ExpandLessIcon';
import ExpandMore from '@portalterreno/react-ui-icons/ExpandMoreIcon';
import React, { useState } from 'react';

export type FooterListItemDiv = React.HTMLAttributes<HTMLDivElement> & {
  primary?: React.ReactNode;
};

export type StyledListItemLinksDivProps =
  React.HTMLAttributes<HTMLDivElement> & {
    isOpen: boolean;
  };

type StyledDivProps = React.HTMLAttributes<HTMLDivElement>;

const StyledListItemLinksDiv = styled.div<StyledListItemLinksDivProps>(
  {
    'backgroundColor': 'inherit',
    'padding': '22px 10px',
    'paddingBottom': 22,
    'width': '100%',
    'boxSizing': 'border-box',
    '&:hover': {
      backgroundColor: 'inherit'
    }
  },
  ({ theme }) => ({
    'color': theme.palette.colors.white,
    '&:hover': {
      color: theme.palette.colors.white
    }
  })
);

const StyledDiv = styled.div<StyledDivProps>(
  {
    'display': 'inline-flex',
    'alignItems': 'center',
    'justifyContent': 'space-between',
    'cursor': 'pointer',
    'width': '100%',
    '& span': {
      width: 'fit-content',
      marginRight: '14px'
    }
  },
  ({ theme }) => ({
    '& span': {
      fontSize: theme.typography.fontSize.large,
      fontWeight: 400
    }
  })
);

const FooterListItem: React.FC<FooterListItemDiv> = ({ children, ...rest }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleIsOpen = React.useCallback(() => {
    setIsOpen((previousState) => !previousState);
  }, []);

  return (
    <StyledListItemLinksDiv
      isOpen={isOpen}
      onClick={toggleIsOpen}
      {...rest}
    >
      <StyledDiv>
        <span>{rest.primary}</span>
        {isOpen ? <ExpandLess /> : <ExpandMore />}
      </StyledDiv>
      {isOpen && children}
    </StyledListItemLinksDiv>
  );
};

export default FooterListItem;
